import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'me-table',
  styleUrl: './me-table.scss',
  shadow: false,
})
export class MeTable {

  @Prop() theme = 'neutral';
  @Prop() striped = true;

  render() {
    const classList = [
      'me-table',
      `me-table--${this.theme}`,
      this.striped ? 'me-table--striped' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList}>
        <slot />
      </Host>
    );
  }
}
